export let $;

export async function importBootstrap() {
    if (!$) {
        const bootstrapExports = await import(/* webpackChunkName: "bootstrap" */ './bootstrap');
        $ = bootstrapExports.$;
    }
}
